import React, { useCallback, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';


export default function Ward1Modal(props) {

    if (!props.open) {
        return null;
    }
    // https://www.vecteezy.com/vector-art/1008568-sick-boy-on-hospital-bed
    return (
        <React.Fragment>

            <div className="Modal">
                <div className="ModalBg">
                    <div className="ModalContent ward1">
                        <header>
                            <h1>Welcome to Children's Ward 1!</h1>
                        </header>
                        <section>
                            <img src={require('../../assets/images/ward1.png')} />

                            Officia anim cillum nulla anim id. Excepteur sint minim exercitation ullamco deserunt et nulla anim excepteur. Proident aute aliqua voluptate ad commodo cillum amet aliquip aute.

                        </section>
                        <footer>
                            <a href="#" onClick={() => props.onClose()}><CloseIcon style={{ fontSize: 60, color: "black" }} /></a>
                        </footer>
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}